const STORAGE_KEY = 'mwsb_wishlist';
const EVENT_NAME  = 'mwsb:wishlist-change';

function getIds() {
	try {
		return JSON.parse( localStorage.getItem( STORAGE_KEY ) || '[]' );
	} catch {
		return [];
	}
}

function setIds( ids ) {
	localStorage.setItem( STORAGE_KEY, JSON.stringify( ids ) );
	window.dispatchEvent( new CustomEvent( EVENT_NAME, { detail: { ids } } ) );
}

export function isInWishlist( productId ) {
	return getIds().includes( productId );
}

export function toggleWishlist( productId ) {
	const ids        = getIds();
	const inWishlist = ids.includes( productId );
	const newIds     = inWishlist
		? ids.filter( ( id ) => id !== productId )
		: [ ...ids, productId ];

	setIds( newIds );

	// Sync to server for logged-in users (silent fail — localStorage is source of truth).
	if ( window.mwsbData?.userId && window.mwsbData?.nonce ) {
		fetch( `${ window.mwsbData.restUrl }/wishlist/toggle`, {
			method:  'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce':   window.mwsbData.nonce,
			},
			body: JSON.stringify( { product_id: productId } ),
		} ).catch( () => {} );
	}

	return ! inWishlist; // true = now in wishlist
}

export function getWishlistIds() {
	return getIds();
}

export function onWishlistChange( callback ) {
	const handler = ( e ) => callback( e.detail.ids );
	window.addEventListener( EVENT_NAME, handler );
	return () => window.removeEventListener( EVENT_NAME, handler );
}

export async function initWishlist() {
	if ( ! window.mwsbData?.userId || ! window.mwsbData?.nonce ) {
		return;
	}

	try {
		const res = await fetch( `${ window.mwsbData.restUrl }/wishlist`, {
			headers: { 'X-WP-Nonce': window.mwsbData.nonce },
		} );
		if ( ! res.ok ) return;

		const { ids: serverIds } = await res.json();
		const localIds           = getIds();
		const merged             = [ ...new Set( [ ...localIds, ...serverIds ] ) ];
		setIds( merged );
	} catch {
		// Ignore — localStorage state stays as-is.
	}
}
